import React, { useContext, useState } from 'react';

import { saveOnlineAnalysis } from '../../Api/OnlineAnalysis';
import { AccountContext } from '../../Context/AccountContext';
import { FilterContext } from '../../Context/FilterContext';
import Button from '../../Form/Button/Button';
import { AccountOnlineAnalysis } from '../../MyLom/Account/EditAccount/Types';
import { initialPayload } from '../OnlineAnalysis';
import { Payload, Questions, QuestionType } from '../Types';

import './Summary.scss';

interface Props {
    page: number;
    currentPage: number;
    payload: Payload;
    questions: Questions;
    setPayload: React.Dispatch<React.SetStateAction<Payload>>;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

enum SaveState {
    'SUCCESS',
    'IN_PROGESS',
    'FAILURE',
}

const Summary: React.FunctionComponent<Props> = (props) => {
    const [saveState, setSaveState] = useState<SaveState | null>(null);

    const { makeOnlineAnalysisOverlayVisible, updateOnlineAnalysis } = useContext(FilterContext);
    const { setAccountData } = useContext(AccountContext);
    if (props.page !== props.currentPage) {
        return null;
    }

    const submit = (activate: boolean) => {
        setSaveState(SaveState.IN_PROGESS);
        saveOnlineAnalysis(
            props.payload,
            (id) => {
                setSaveState(SaveState.SUCCESS);
                makeOnlineAnalysisOverlayVisible(false);
                props.setPayload(initialPayload);
                props.setCurrentPage(1);
                const newOnlineAnalysis: AccountOnlineAnalysis = {
                    answers: { ...props.payload },
                    id,
                    creationDateTime: new Date(),
                };

                setAccountData((accountData) => {
                    if (accountData) {
                        return {
                            ...accountData,
                            onlineAnalyses: [...accountData.onlineAnalyses, newOnlineAnalysis],
                        };
                    }
                    return null;
                });

                if (activate === true) {
                    updateOnlineAnalysis(newOnlineAnalysis);
                }
            },
            () => {
                setSaveState(SaveState.FAILURE);
            },
            () => {
                setSaveState(SaveState.FAILURE);
            },
        );
    };

    return (
        <div className="online-analysis__summary">
            <h2>Zusammenfassung</h2>
            <table>
                <tbody>
                    {Object.entries(props.questions).map(([key, question]: [string, QuestionType]) => {
                        if (key === 'skinCharacteristics') {
                            return null;
                        }
                        return (
                            <tr key={key}>
                                <td>
                                    <strong>{question.label}</strong>
                                </td>
                                <td>
                                    {question.answers
                                        .filter((answer) => answer.value === props.payload[question.id])
                                        .map((answer) => answer.label)}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            {props.payload.skinCharacteristics.length > 0 ? (
                <>
                    <h4>Hautbesonderheiten</h4>
                    {props.questions.skinCharacteristics.answers.map((skinCharacteristic) => {
                        if (
                            skinCharacteristic.answers.some((answer) =>
                                props.payload.skinCharacteristics.includes(answer.value),
                            )
                        ) {
                            return (
                                <>
                                    <strong>{skinCharacteristic.label}</strong>
                                    <ul>
                                        {skinCharacteristic.answers
                                            .filter((answer) =>
                                                props.payload.skinCharacteristics.includes(answer.value),
                                            )
                                            .map((answer) => (
                                                <li key={answer.value}>{answer.label}</li>
                                            ))}
                                    </ul>
                                </>
                            );
                        }
                    })}
                </>
            ) : null}

            <div className="online-analysis__summary-actions">
                <Button onClick={() => submit(false)} primary={true} disabled={saveState === SaveState.IN_PROGESS}>
                    Hautbild speichern
                </Button>
                <Button onClick={() => submit(true)} primary={true} disabled={saveState === SaveState.IN_PROGESS}>
                    Hautbild speichern und anwenden
                </Button>
            </div>

            {saveState === SaveState.FAILURE ? (
                <p className="online-analysis__summary-failure">
                    Leider gab es bei der Speicherung Ihrer Online Hautbild Analyse ein Problem. Bitte versuchen Sie es
                    in Kürze erneut.
                </p>
            ) : null}
        </div>
    );
};

export default Summary;
